// Work in progress
import { atom } from 'nanostores';
import type { DeploymentStatus, NetlifyState } from '~/lib/types/netlify';

// Create the store with initial state
export const netlifyStore = atom<NetlifyState>({
  deployedId: null,
  deploymentStatus: 'idle',
  deployedUrl: null,
  error: null,
  adminUrl: null,
  previousDeployUrl: null,
  isCheckingStatus: false,
  hasExistingDeployment: false,
  screenshotUrl: null,
  isCommunityApproved: false,
  preAdminUrl: null,
  isErrorFixable: true,
});

// Action creators
export const setDeployedId = (id: string) => {
  netlifyStore.set({ ...netlifyStore.get(), deployedId: id });
};

export const setDeploymentStatus = (status: DeploymentStatus) => {
  netlifyStore.set({ ...netlifyStore.get(), deploymentStatus: status });
};

export const setDeployedUrl = (url: string) => {
  netlifyStore.set({ ...netlifyStore.get(), deployedUrl: url });
};

export const setError = (error: string) => {
  netlifyStore.set({ ...netlifyStore.get(), error });
};

export const setAdminUrl = (url: string) => {
  netlifyStore.set({ ...netlifyStore.get(), adminUrl: url });
};

export const setPreviousDeployUrl = (url: string) => {
  netlifyStore.set({ ...netlifyStore.get(), previousDeployUrl: url, hasExistingDeployment: true });
};

export const setIsCheckingStatus = (isChecking: boolean) => {
  netlifyStore.set({ ...netlifyStore.get(), isCheckingStatus: isChecking });
};

export const setHasExistingDeployment = (hasExisting: boolean) => {
  netlifyStore.set({ ...netlifyStore.get(), hasExistingDeployment: hasExisting });
};

export const setScreenshotUrl = (url: string) => {
  netlifyStore.set({ ...netlifyStore.get(), screenshotUrl: url });
};

export const setIsCommunityApproved = (isApproved: boolean) => {
  netlifyStore.set({ ...netlifyStore.get(), isCommunityApproved: isApproved });
};

export const setPreAdminUrl = (url: string) => {
  netlifyStore.set({ ...netlifyStore.get(), preAdminUrl: url });
};

export const setIsErrorFixable = (isFixable: boolean) => {
  netlifyStore.set({ ...netlifyStore.get(), isErrorFixable: isFixable });
};

export const resetNetlifyStore = () => {
  netlifyStore.set({
    deployedId: null,
    deploymentStatus: 'idle',
    deployedUrl: null,
    error: null,
    adminUrl: null,
    previousDeployUrl: null,
    isCheckingStatus: false,
    hasExistingDeployment: false,
    screenshotUrl: null,
    isCommunityApproved: false,
    preAdminUrl: null,
    isErrorFixable: true,
  });
};
